import { ICONS } from 'src/assets/library';
import SvgColor from '../../../components/svgColor/SvgColor';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.png`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/',
    icon: icon('dash'),
  },
  {
    title: 'bookings',
    path: '/booking',
    icon: icon('closed'),
  },
  {
    title: 'rejected',
    path: '/rejected',
    icon: icon('warning'),
  },
  {
    title: 'Settings',
    path: '/setting',
    icon: ICONS.setting,
  },
  {
    title: 'Users',
    icon: ICONS.user,
    children: [
      {
        title: 'Admin',
        path: '/user',
        icon: ICONS.user,
      },
      {
        title: 'Driver',
        path: '/driver',
        icon: ICONS.driver,
      },
    ],
  },
  {
    title: 'trash bin',
    path: '/deleted',
    icon: icon('recycle'),
  },
];

export default navConfig;
